// USA
export const locale = {
  lang: {
    russian: "Русский",
    uzbekLatin: "O‘zbek (Lotin)",
    uzbekKrill: "Ўзбек (кирилл)",
    kr: "Qaraqalpaq (latın)",
  },
  lotin: " (lotincha)",
  search: "Qidiruv",
  selectedVakant: "Tanlangan bo'sh ish o'rinlari",
  obnamuna: "Obyektivka namunasi",
  staff_requirement_1: "Lavozimning faoliyat yoʼnalishi va vazifalari",
  staff_requirement_2: "Lavozim uchun rasmiy talablar",
  with_me: "Biz bilan quyidagi natijalarga erishishingiz mumkin",
  staff_requirement_card_1:
    "Barcha mehnat sharoitlari yaratilgan zamonaviy idora",
  staff_requirement_card_2: "Zamonaviy fikrlaydigan va ahil mehnat jamoasi",
  staff_requirement_card_3:
    "Munosib ish haqi (maxsus unvon-martaba darajasi, ish staji, oylik shaxsiy ustama va boshqa qoʼshimchalar)",
  staff_requirement_card_4:
    "Ishonchli xizmat karьerasi, yuqori lavozimlarga koʼtarilish imkoniyati",
  staff_requirement_card_5:
    "Professional xodimlar orasida katta ish tajribasi va bebaho kasbiy koʼnikmalarni orttirish imkoniyati",
  staff_requirement_card_6:
    "Xorijda malaka oshirish va stajirovka oʼtash imkoniyati",
  home: {
    menuText1: "Adliya organlari va muassasalarida",
    menuText2: "bo'sh ish o'rinlari",
    search: "Adliya organlari va muassasalari",
    countEnnounment: "Aktiv e'lonlar",
    countEnnounmentInactive: "Arxivdagi e'lonlar",
    searchRegion: "Hudud bo'yicha qidiruv",
    searchJob: "Lavozim bo'yicha qidiruv",
    statistic: "Statistika",
    vacancyCount: "E'lonlar",
    vacancies: "Bo'sh ish o'rinlari",
    applicants: "Hujjat topshirganlar",
    recruited: "Ishga olinganlar",
    lavozim: "Lavozim",
    vacancy: "Bo'sh ish o'rni",
    company: "Oʻzbekiston Respublikasi Adliya vazirligi",
    havola: "Bizning manzillar",
    nomzod: "Nomzodlar",
    close: "Yopish",
    sendDocument: "Hujjatlarni yuborish",
    aboutLavozim: "Lavozim haqida",
    aboutAll: "umumiy ma'lumot",
    vazirlik: "Vazirlik",
    bolim: "Boshqarma(bo'lim)",
    lavozimToifa: "Lavozim toifasi",
    lavozim: "Lavozim",
    jobOn: "Bo'sh ish o'rni",
    createDate: "E'lon berilgan sanasi",
    finishDate: "E'lon tugash sanasi",
    modalTitle:"ID-karta olganingizdan so‘ng, OneID tizimidan ma'lumotlaringizni yangilang",
    skipping: "O‘tkazib yuborish",
    updateInformation: "Ma'lumotlarni yangilash"
  },
  status: "Holati",
  seriaNumber: "Pasport seriyasi va raqam",
  secury: {
    fullMsg:
      "Parol kamida 8 ta belgidan va loaqal bitta kichik harf, bitta katta harf, bitta raqam va bitta maxsus belgidan iborat bo'lishi kerak.",
    msg1: "Parol ",
    msg2: "kamida 8 ta belgidan ",
    msg3: "loaqal bitta raqamdan ",
    msg4: "loaqal bitta kichik harfdan ",
    msg5: "loaqal bitta katta harfdan ",
    msg6: "loaqal bitta maxsus belgidan ",
    msg7: " iborat bo'lishi kerak.",
    msg8: "Kirill alifbosidan foydalanmang",
    successPswdSecury: "Parol qabul qilindi.",
    successNoPswdSecury: "Parol qabul qilinmadi.",
  },
  photoCan: "Nomzodning rasmi",
  usernameAlready: "Ushbu foydalanuvchi nomi allaqachon mavjud",
  isSaved: "Kiritilgan ma'lumotlarni saqlaysizmi?",
  messages: "Xabarlar",
  org: "Tashkilot",
  annoucement: "E'lonlar",
  additionalDoc: "Qo'shimcha hujjatlar yuklash",
  expireDateMessage: "Test topshirish uchun berilgan muddat tugadi",
  pasportInfo: "Pasport ma'lumotlari",
  showArizaInfo: "Nomzodning arizasi",
  finishSure: "Sinovni tugatishingizga aminmisiz",
  testAnswers: "Test javoblari",
  expiredDate: "Tugash muddati",
  givenDate: "Berilgan sana",
  createdDate: "Elon qo'shilgan sana",
  variantlar: "Variantlar",
  inPercent: "Test javobi foizda",
  result: "Natija",
  testResult: "Test natijalari",
  doc: "Hujjatlar",
  nameDoc: "Hujjat nomi",
  allTest: "Jami savollar soni",
  allTestCorrect: "To'g'ri javoblar soni",
  EmployeeFIO: "Nomzod",
  allTestNoCorrect: "Noto'g'ri javoblar soni",
  forLogin: "Tizimga kirish uchun",
  status: {
    PASSED_TEST: "Test muvaffaqiyatli yakunlandi",
    FAILED_TEST: "Testdan o'tolmadi",
    TEST: "Тest topshirish",
    MEETING: "Nomzod bilan uchrashuv",
    SEND_DOCUMENT: "Hujjatlar yuborildi",
    SEEN: "Nomzodning hujjatlari ko'rib chiqildi",
    REGISTERED: "Nomzod ro'yxatdan o'tdi",
    CONTRACT: "Shartnoma",
    NOT_ACCEPTED: "Qabul qilinmadi",
    TEST_PROCESS: "Test boshlandi",
    PASSED_MEETING: "Suhbatdan o'tdi",
    FAILED_MEETING: "Suhbatdan o'tolmadi",
    JOB_SUBMIT: "Ishga qabul qilingan",
    DELETED: "Qaytarib olingan",
  },
  warning: {
    enter: "Malumotlarni to'liq kiritish kerak",
    noInformation: "Ma'lumot topilmadi",
    noChoosen: "Fayl tanlanmagan",
    noInfo: "Agar sizda ma'lumot bo'lmasa",
    dataIncomplate: "Iltimos ma'lumotlarni to'g'ri kiriting",
    tokenExpired: "Token muddati tugagan",
    sure: "Ishonchingiz komilmi",
    finishTest: "Test vaqti tugadi",
    notSaved: "O'zgarishlar saqlanib qolmasligi mumkin",
    successReg: "Ro'yxatdan muvaffaqiyatli o'tdingiz",
    warInfo: "Shaxsiy kabinetingizdagi ma'lumotlarni to'ldiring",
    selectInfo: "Ushbu e'londagi bo'sh ish o'rniga hujjat topshirgansiz",
    loginInfo:
      "Hujjat yuborishdan oldin shaxsiy kabinetingizga kirgan bo'lishingiz kerak!",
  },
  percent: {
    title: "Foiz",
    sign: "%",
  },
  allowance: {
    percent: "Foiz %",
    department: "Bo'lim",
  },
  succes: {
    SEND_DOCUMENT: "Hujjatlar yuborildi",
    saved: "Muvaffaqiyatli saqlandi",
    createEmployee: "Xodim muvaffaqiyatli yaratildi!",
  },
  numberAnnounsment: "E'lon raqami",
  orderNumber: "Tartib raqami",
  transliteratsiya: "Transliteratsiya",
  dashboard: "Menyu",
  total: "Umumiy",
  empty: "Bo'sh",
  other: "Boshqalar",
  recentActivity: "So'nggi harakatlar",
  answerDoc: "Javob xati",
  login: {
    loginWithOneId: "One Id orqali kirish",
    videoInfo: "Tanlovga hujjatlarni taqdim qilish",
    videoLesson: "bo'yicha video qo'llanma",
    email: "Elektron pochta manzili",
    verify: "Tasdiqlang",
    phone: "Telefon",
    byToken: "Kalit bilan tizimga kiring",
    username: "Foydalanuvchi nomi (Login)",
    password: "Parol",
    title: "Tizimga kirish",
    account: "Hisobingizga kiring",
    come_out: "Kirish",
    come_up: "Chiqish",
    update: "Kalit so'zni o'zgartirish",
    userProfile: "Foydalanuvchining profili",
    currentPassword: "Hozirgi ka'lit so'z",
    newPassword: "Yangi ka'lit so'z",
    confirmPassword: "Ka'lit so'zni tasdiqlang",
    misMatch: "Parol tog'ri emas",
    inn: "STIR",
    fio: "To'liq ismi sharifi",
    org: "Tashkilot",
    srokLicence: "Sertifikatning amal qilish muddati",
    numberLicence: "Litsenziya raqami",

    enteredInfo: "Shaxsiy malumotlarni kiritish",
    ByregisteredInfo:
      "Ro'yxatdan o'tganingizda foydalangan elektron pochta yoki telefon raqamizni kiriting",
    forgetPasswordTitle:
      "Xavfsizlik sababli, bu haqiqatan ham siz ekanligingizga ishonch hosil qilishimiz kerak. Davom etish uchun quyidagi shaxsiy ma'lumotlaringizni qayta kiriting.",
    forgetTitle: "Quyidagi shaxsiy ma'lumotlaringizdan birini kiriting",
    byusername: "Foydalanuvchi nomi",
    bypassport: "Pasport seriyasi va raqami",
    Byregistered:
      "Ro'yxatdan o'tganingizda foydalangan elektron pochta yoki telefon raqamni tanlang",
    sendConfirmCode: "Yuborilgan tasdiqlash kodi va yangi parolni kiriting",
    confirmCode: "Tasdiqlash kodi",
    newPasswordEntered: "Yangi parol",
    forgetConfirm: "Tasdiqlash",

    forgetPassword: "Parolni unutdingizmi?",
    or: "Yoki",
    account: "Akkount yarataszmi?",
    registration: "Ro'yxatdan o'tish",
    oferta:
      "Men ommaviy taklif shartlarini qabul qilaman va shaxsiy ma'lumotlarimni qayta ishlashga roziman",
    accountYes: "Akkountingiz mavjudmi?",
    verifiyCodeWhere: "Tasdiqlash kodini qayerga yuborish kerak?",
    enteredEmail: "Emailni kiriting",
    yourDid: "Siz bu narsalarni qildingiz!",
  },
  register: {
    text: {
      text1:
        "ADLIYA ORGANLARI VA MUASSASALARIDA XODIMLARNI ISHGA QABUL QILISH TARTIBI",
      text2: "Umumiy qoidalar",
      text3:
        "Adliya organlari va muassasalariga jinsi, yoshi, irqi, millati, tili, ijtimoiy kelib chiqishi, mulkiy holati va mansab mavqei, dinga bo‘lgan munosabati, e’tiqodi, jamoat birlashmalariga mansubligidan qat’i nazar, o‘zining kasbiy, ishchanlik, shaxsiy va axloqiy fazilatlari, ma’lumoti darajasi va sog‘lig‘iga ko‘ra adliya organlari va muassasalariga yuklatilgan vazifalarni bajarishga qodir bo‘lgan O‘zbekiston Respublikasi fuqarolari yoki O‘zbekiston Respublikasi Prezidentining alohida qarorlari bilan o‘rnatilgan tartibda xorijiy davlatlarning fuqarolari va fuqaroligi bo‘lmagan shaxslar qabul qilinadi.",
      text4:
        "Quyidagilar adliya organlari va muassasalariga ishga qabul qilinishi mumkin emas:",
    },
    phone: "Telefon",
    getconfirmCode: "Jo'natish",
    title: "Ro'yxatdan o'tish",
    firstName: "Ism",
    lastName: "Familiya",
    username: "Foydalanuvchi nomi (Login)",
    passport: "Pasport seriyasi va raqami",
    password: "Parol",
    confirmPassword: "Parolni tasdiqlang",
    email: "Email",
    confirmCode: "Tasdiqlash kodi",
    next: "Keyingi",
    info_1: "Roʻyxatdan oʻtishda yoki parolni tiklashda muammo yuzaga kelganda",
    info_2: "telegram botga murojaat qiling",
  },
  actions: {
    usernameError: "Bo'sh joy kiritish mumkin emas!",
    tests: "Testlar ro'yxati",
    print: "Chop etish",
    enteredEmail: "Elekton pochta manzilingizni kiriting",
    enterPhone: "Telefon nomeringizni kiriting",
    changeInfo: "Ma'lumot kiritish",
    selectKey: "Ushbu kalitni tanlang",
    read: "O'qish",
    download: "Yuklab olish",
    uploadDiplom: "Diplomni yuklash",
    uploadObyektivka: "Obektivkani yuklash",
    select: "Tanlash",
    selectVacancy: "Bo'sh ish o'rinlarini tanlash",
    yes: "Xa",
    no: "Yo'q",
    selectAnnoucement: "E'lonni tanlash",
    back: "Orqaga",
    addQuestion: "Savol yasash",
    uploadImage: "Rasm yuklash",
    uploadCopy: "Pasport nusxasini yuklash",
    sendDocument: "Hujjatlarni yuborish",
    send: "Yuborish",
    clear: "Tozalash",
    createEmployee: "Xodim yaratish",
    sendForConfirmation: "Tasdiqlash uchun yuboring",
    enterSomeThing: "Biror narsani kiriting ..",
    title: "Harakatlar",
    add: "Qo'shish",
    save: "Saqlash",
    cancel: "Bekor qilish",
    next: "Keyingi",
    prev: "Oldingi",
    choose_file: "Faylni tanlang",
    filter: "Saralash",
    delete: "O'chirish",
    update: "Yangilash",
    all: "Hammasi",
    edit: "Tahrirlash",
    editData: "Ma'lumotlarni tahrirlash",
    displayAll: "Hammasini ko'rsatish",
    choosePhoto: "Suratni tanlang",
    selectAll: "Hammasini tanlang",
    createUser: "Foydalanuvchini yarating",
    finishTest: "Testni tugatish",
  },
  savol: {
    en: "Savol (lotin)",
    ru: "Вопрос(русский)",
    uz: "Савол(кирилл)",
    kr: "Qaraqalpaq",
  },
  variant: {
    en: "Variant (lotin)",
    ru: "Вариант(русский)",
    uz: "Вариант(кирилл)",
    kr: "Qaraqalpaq",
  },
  error: {
    passport_error:
      "Passport seriasini kiritish majburiy va uzunligi 2 ta bo'lishi kerak",
    name_error: "Bu maydon bo‘sh bo‘lishi mumkin emas",
    netToken: "Sizda kalit yo‘q",
    login_error: "Foydalanuvchi nomi yoki parol xato",
    already_success: "Siz ro'yhatdan o'tgansiz...",
    netAccess: "Ruxsat yo‘q",
    title: "Xatolik! ",
  },
  staff: {
    totalStavka: "Umumiy ish tajribasi",
    stavka: "Stavka",
    salary: "Ish haqi",
    arxiv: "Shtatlar jadvali arxivi",
    changeReason: "Shtatlar jadvalining o'zgarishi sababi",
    list: "Shtatlar jadvali",
    minSalary: "Eng kam ish haqi",
    position: "Lavozim",
    typePosition: "Lavozim tu'ri",
    workWithDepartments: "Bo'limlar bilan ishlash",
    workWithPosition: "Lavozimlar bilan ishlash",
    staffCount: "Shtatlar soni",
    status: "Status",
    vacancy: "Bo'sh ish o'rni",
    workLoadStaff: "Shtatlarning ish yuklamalari",
    refPosition: "Lavozimlar",
    allowances: "Imtiyozlar",
    ranks: "Daraja",
    tariff: "Ta'rif",
  },
  menu: "Menyu",
  employees: {
    pnfl: "JSHSHIR ko'rish",
    searchPnfl:"JSHSHIR",
    dataPassport: "Pasport ma'lumotlarini olish",
    addresss: "Manzil",
    title: "Xodimlar",
    personalCard: "Shaxsiy varaqasi",
    birthDate: "Tug'ilgan sana",
    appointmentsTransfers: "Tayinlanish va o'tkazish",
    rotation: "Xodimlarni rotatsiya qilish",
    dismissal: "Xodimni bo'shatish",
    dismissedList: "Bo'shatilgan xodimlar ro'yxati",
    fullName: "FIO",
    language: "Til",
    language_status: "Til holati",
    rectal: "Xarbiy unvon",
    holiday: "Bayramlar",
    profile: "Profil",
    profileBack: "Profilga qaytish",
    ob: "Obektivka",
    passport: "Pasport",
    endBeginPassport: "Pasportning tugash va boshlanish sanasi",
    firstName: "Ism",
    lastName: "Familiya",
    parentName: "Otasining ismi",
    email: "Elektron pochta manzil",
    phone: "Telefon",
    mobilePhone: "Qo'shimcha telefon",
    address: "yashash manzili",
    birthAddress: "Tug'ilgan joyi",
    birthRegion: "Tug'ilgan viloyati",
    location: "Yashash joyi",
    placeBirth: "Tug'ilgan joyi",
    passportId: "Pasport raqami",
    passportGivenDate: "Pasport berilgan sana",
    passportEndDate: "Passportning amal qilish muddati",
    passportGivenWho: "Pasport kim tomonidan berilgan",
    inpc: "JSHSHIR",
    photo: "Xodimning fotosurati",
    copyPassport: "Pasport nusxasi",
    manage: "Xodimlarni boshqarish",
    workingDetails: "Ish tafsilotlari",
    seniority: "Ish staji",
    foreignLang: "Xorijiy tillar",
    familyMembers: "Oila a'zolari",
    partyMembership: "Partiya a'zoligi",
    academic_title: "Ilmiy unvon",
    academic_degree: "Ilmiy darajasi",
    state_awards: "Davlat mukofotlari",
    education: "Ta'lim",
    isHeDeputy: "Deputatligi",
    phones: "Telefonlar",
    endDate: "Ishdan bo'shatish sanasi",
    beginDate: "Ishga joylashish sanasi",
    system: "Tizim",
    whereWorked: "Qayerda va kim bo'lib ishlagan",
    givenYear: "Berilgan sana",
    dead: "Vafot etgan",
    alive: "Hayot",
    reason: "Sababi",
  },
  staffing: {
    title: "Shtatlar jadvali",
    totalVacancy: "Jami bo'sh ish o'rinlari",
    totalStaff: "Ja'mi shtatlar soni",
  },
  orders: {
    title: "Buyruqlar",
    list: "Buyruqlar ro'yxati",
    number: "Buyruq raqami",
    date: "Buyruq sanasi",
    type: "Buyruq turi",
    summary: "Xulosa",
    contractNumber: "Mehnat shartnomasi raqami",
    dateOfEmployment: "Ishga joylashish sanasi",
  },
  certification: {
    title: "Attestatsiya",
  },
  vacation: {
    title: "Ta'til",
    send: "Та'tilga chiqarish",
    on: "Ayni vaqtda ta'tildagi xodimlar",
    plan: "Тa'tillar rejasi",
    labor: "Yillik mehnat ta'tili",
    tempAllowance: "Mehnatga layoqatsizlik varaqasi",
    withoutPay: "Ish haqi saqlanmagan holda beriladigan ta'til ",
    careChild: "Bola parvarishlash ta'tili",
    nextlabor: "Navbatdagi mehnat ta'tiliga chiqqan xodimlar",
    withoutContent:
      "Ish haqi saqlanmagan holda beriladigan ta'tilga chiqqan xodimlar",
    sickWorkers: "Mexnatga layoqatsizlik tufayli ta'tilga chiqqan xodimlar",
    maternity: "Bola parvarishlash ta'tiliga chiqqan xodimlar",
  },
  monitoringEmployees: {
    title: "Xodimlarni monitoring qilish",
  },
  businessTrips: {
    title: "Xizmat safari",
    enterData: "Xizmat safarini belgilash",
    on: "Xizmat safaridagi xodimlar",
  },
  awardsAndBonus: {
    title: "Mukofotlar va imtiyozlar",
  },
  recruitment: {
    title: "Ishga qabul qilish",
    etap: "Bosqich",
    pasportData: "Pasport ma'lumotlari",
    enterpasportData: "Kiritilgan pasport ma'lumotlari",
    degreeEducation: "Ilmiy darajasi",
    seniority: "Ish tajribasi",
    familyMembers: "Oila a'zolari",
    additionalData: "Qo'shimcha ma'lumotlar",
  },
  departments: "Bo'limlar",
  references: {
    accept: "Qabul qilish",
    title: "Ma'lumotnoma",
    all: "Hamma ma'lumotnomalar",

    holiday: "Bayramlar",
    nationality: "Millati",
    rectal: "Harbiy unvoni",
    spec_diplom: "Maxsus diplom",
    news: " Yangiliklar",
    country: "Mamlakat",
    department_type: "Bo'lim turi",
    order_type: "Buyruq turi",
    work_mode: "Ish tartibi",
    department: "Bo'lim",
    holiday_type: "Bayram turlari",
    gender: "Jinsi",
    marital_status: "Oilaviy holati",
    passport_seria: "Pasport seriya",
    academic_degree: "Ilmiy darajasi",
    academic_title: "Ilmiy unvon",
    award: "Mukofat",
    exactAdress: "Vaqtincha turar joyi",
    education: "Ma'lumoti",
    propis: "Doimiy yashash joyi",
    region: "Yashash hududi",
    regions: "Tug'ilgan hududi",
    language: "Til",
    passportTYpe: "Pasport turi",
    language_status: "Til holati",
    military_rank: "Harbiy unvon",
    party_membership: "Partiyaga a'zolik",
    reason_for_dismissal: "Ishdan bo'shatish sababi",
    educational_institution: "Ta'lim muassasasi",
    education_type: "Maʼlumoti boʼyicha mutaxassisligi",
    family_member: "Oila a'zolari",
    directory_phone_type: "Telefon turi",
    vatInfo: "QQS (%)",
    bankRequesit: "Bank rekvizitlari",
    bank: "Bank",
    bankAccountType: "Hisob turi",
    accountNumber: "Bank hisob raqami",
    depManagement: "Bo'limlarni boshqarish",
    endDate: "Bitiruv yili",
  },
  name: {
    en: "Nomi(lotin)",
    ru: "Nomi(rus)",
    uz: "Nomi(kirill)",
    kr: "Qaraqalpaq (latın)",
  },
  address: {
    title: "Manzil",
    lt: "Manzil(lotin)",
    ru: "Адрес(русский)",
    uz: "Manzil(кирилл)",
    physical: "Jismoniy joylashuvi",
    legal: "Yuridik manzili",
    phone: "Telefon",
    email: "Elektron pochta manzili",
  },
  userManagement: {
    title: "Foydalanuvchilarni boshqarish",
    roles: "Rollar",
    permissions: "Ruxsatlar",
    users: "Foydalanuvchilar",
  },
  roles: {
    name: "Nomi",
    code: "Kodi",
    permissions: "Ruxsatlar",
  },
  permissions: {
    title: "Ruxsatlar",
    name: "Ism",
    type: "Turi",
    code: "Kod",
    sort: "Saralash",
  },
  date: "Sana",
  createdDate: "Yaratilgan sana",
  confirm_delete: "Haqiqatan ham o'chirmoqchimisiz",

  permessionMangement: {
    References: "Ma'lumotnoma",
    Department: "Bo'lim",
    DirectoryOrder: "Buyruqlar ro'yhati",
    EmployeeAllowance: "Imtiyozlar",
    EmployeeAcademicTitle: "Ilmiy unvon",
    EmployeeLanguage: "Til",
    EmployeeAward: "Sovrin",
    EmployeeRectal: "Harbiy unvoni",
    EmployeeWork: "Xodimlarning ishi",
    Employee: "Xodimlar",
    EmployeeFamilyMember: "Oila a'zolari",
    EmployeeMemberOfDeputy: "Deputatligi",
    EmployeeAcademicDegree: "Ilmiy darajasi",
    EmployeeEducation: "Ta'lim",
    EmployeeHoliday: "Bayramlar",
    MemberOfDeputy: "Partiya a'zoligi",
    EmployeePhoto: "Xodimlarning fotosurati",
    EmployeePhoneNumber: "Telefon",
    EmployeeExperience: "Ish tajribasi",
    EmployeePartial: "Qisman",
    EmployeeWageHistory: "Ish haqi tarixi",
    EmployeePassportScan: "Pasport nusxasi",

    //STAFF
    StaffListCheckAllowance: "Imtiyozlarni tekshiring",
    StaffList: "Xodimlar jadvali",
    StaffPosition: "Lavozim",
    StaffListChangeReason: "Kadrlar jadvalidagi o'zgarishlarning sababi",
    StaffListArchive: "Kadrlar arxivi",
    StaffMinSalary: "Minimal ish haqi",
    StaffListAllowance: "Imtiyozlar",

    //OTHER
    DepartmentAddress: "Bo'lim manzili",
    TimeSheetControl: "Vaqt varaqasi",
    BankRequisite: "Bank tafsilotlari",
    News: "Yangiliklar",
    Role: "Rollar",
    VATInfo: "QQS (%)",
    User: "Foydalanuvchilar",
  },
  forgetPasswordText:
    "Ro'yxatdan o'tgan tel nomeringizga kodni jo'natshimiz uchun passport ma'lumotingizni kiriting:",
  required_error: "Barcha kerakli maydonlarni toʻldiring",
  send_code: "Telefon raqamingizga kod jonatildi !",
  success: "Muvaffaqiyatli saqlandi !",
  password_error: "Parol 8 xonadan kam bolishi kerak emas!",
  resultFound: "ta e'lon topildi",
  returnDocument: "Hujjatni qaytarib olish",
  returned: "Hujjat qaytarib olindi",
  statusAriza: "ARIZANGIZNING JORIY XOLATI",
  archiveInfo: "O`zgarishlar tarixi",
  updatedDate: "O'zgartiriligan sana",
  archive: "arxiv",
  returnDoc:
    "Eslatma: hujjat qaytarib olingandan so‘ng, ushbu e’lon doirasida hujjatlar yana qayta yuborilmaydi",
  onlyLotin: "Krill alifbosi harflari ishlatish mumkin emas",
  //
  agreeTest: "Tartib bilan tanishib chiqdim, testlarni yechishga tayyorman",
  alertText: `Adliya vazirligining axborot resurslari uchun internet tarmog‘iga ulanish xizmatlarini ko‘rsatuvchi “ONE-NET” operatori tomonidan 2023 yilning <b> 9-10-11 iyun  kunlari soat 00-00 dan 06-00 ga qadar</b> texnik ishlari olib borilishi munosabati bilan Adliya vazirligi axborot tizimlari ishida qisqa muddatli uzilishlar kuzatilishi mumkin.
  <br/> <strong> Shu sababli nomzodlarga ushbu vaqt oralig‘ida bo‘sh ish o‘rinlari bo‘yicha tanlovlarning  test sinovini topshirish tavsiya qilinmaydi.</strong>`,
  notice : "Eslatma",
  IAgree  : "Tanishdim",
 
};
